<div>
  <h2>{{ title }}</h2>
  <h4>{{ subtitle }}</h4>
  <p>
    <span>Get Modal instance in component</span>
    <button ui-button [buttonType]="'primary'" (click)="destroyModal()">destroy modal in the component</button>
  </p>
</div>
